module.exports = __webpack_public_path__ + "img/20191204172305793.7dc7b57a.jpg";